import { createRoute } from '@tanstack/react-router'
import ProfilesPage from '@/features/profiles/pages/ProfilesPage'
import { Route as profilesRoute } from '../profiles'

export const Route = createRoute({
  getParentRoute: () => profilesRoute,
  path: '/',
  component: ProfilesPage,
})
